import { BaseErrorLayout } from '@dvb/ui';

export function RootError() {
  return <BaseErrorLayout className="bg-background w-full" />;
}
